import { Household } from "@/types/types";

type Props = {
  className?: string;
  household: Household | undefined | Partial<Household>;
  selectedClientExternalCode: string | null | undefined;
  setSelectedClientExternalCode: React.Dispatch<React.SetStateAction<string | null | undefined>>;
};

export default function HouseholdClientTabs({
  className,
  household,
  selectedClientExternalCode,
  setSelectedClientExternalCode,
}: Props) {
  return (
    <div className={`flex items-center ${className}`}>
      {household?.primaryContact?.birthDate ? (
        <button
          className={`min-w-[6.5625rem] px-4 py-[12px] ${
            selectedClientExternalCode === household?.primaryContact?.externalCode
              ? "bg-tertiary rounded-[4px] font-medium text-white"
              : "text-neutral-300"
          }`}
          onClick={() => {
            setSelectedClientExternalCode(household?.primaryContact?.externalCode);
          }}
        >
          {`${household?.primaryContact?.preferredFirstName}`}
        </button>
      ) : null}
      {household?.secondaryContact?.birthDate ? (
        <button
          className={`min-w-[6.5625rem] px-4 py-[12px] ${
            selectedClientExternalCode === household?.secondaryContact?.externalCode
              ? "bg-tertiary rounded-[4px] font-medium text-white"
              : "text-neutral-300"
          }`}
          onClick={() => setSelectedClientExternalCode(household?.secondaryContact?.externalCode)}
        >
          {`${household?.secondaryContact?.preferredFirstName}`}
        </button>
      ) : null}
    </div>
  );
}
